// src/setupPromiseDebug.js
function toError(reason) {
    if (reason instanceof Error) return reason;
    try { return new Error(typeof reason === 'string' ? reason : JSON.stringify(reason)); }
    catch { return new Error(String(reason)); }
}

window.addEventListener('unhandledrejection', (e) => {
    const err = toError(e.reason);
    // Mostra TUTTO, compreso chi ha rifiutato con null
    console.error('[unhandledrejection]', err, err.stack, { rawReason: e.reason });
});

window.addEventListener('error', (e) => {
    console.error('[error]', e.error || e.message, e.error?.stack, { raw: e });
});
